module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-bank-christian.7dce27f0.jpeg";